<template>
  <div
    ref="container"
    class="marquee"
    style="--marquee-width: 130px"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Marquee',
  props: {
    speed: { type: Number, default: 65 },
    wait: { type: Number, default: 1000 },
  },
  data() {
    return {
      marqueeAnimation: null,
      resizeObserver: null,
    };
  },
  methods: {
    updateMarquee() {
      const { container } = this.$refs;
      // find the <p> element inside the slot
      const txt = container.querySelector('p');
      if (!txt) return;

      const cw = container.clientWidth;
      const tw = txt.scrollWidth;

      container.style.setProperty('--marquee-width', `${cw}px`);

      if (this.marqueeAnimation) this.marqueeAnimation.cancel();
      if (tw <= cw) {
        txt.style.transform = '';
        txt.style.maskPosition = '';
        txt.style.maskImage = 'none';
        return;
      }

      txt.style.maskImage = '';
      const distance = tw - cw;
      const slideDuration = (distance / this.speed) * 1000;
      const totalDuration = this.wait * 2 + slideDuration;

      this.marqueeAnimation = txt.animate([
        { transform: 'translateX(0)', maskPosition: '-5px 0', offset: 0 },
        { transform: 'translateX(0)', maskPosition: '-5px 0', offset: this.wait / totalDuration },
        { transform: `translateX(-${distance}px)`, maskPosition: 'calc(100% + 5px) 0', offset: (this.wait + slideDuration) / totalDuration },
        { transform: `translateX(-${distance}px)`, maskPosition: 'calc(100% + 5px) 0', offset: 1 },
      ], {
        duration: totalDuration,
        iterations: Infinity,
        easing: 'linear',
        direction: 'alternate',
      });
    },
    initObserver() {
      this.resizeObserver = new ResizeObserver(this.updateMarquee);
      this.resizeObserver.observe(this.$refs.container);
      this.resizeObserver.observe(this.$refs.container.querySelector('p'));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateMarquee();
      this.initObserver();
    });
  },
  beforeDestroy() {
    if (this.marqueeAnimation) this.marqueeAnimation.cancel();
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  watch: {
    width() {
      this.$nextTick(this.updateMarquee);
    },
  },
};
</script>

<style scoped>
.marquee {
  display: block;
  position: relative;
  overflow: visible;
  height: 20px;
  margin-bottom: 3px;
}

/* apply marquee-text styles to any <p> slotted inside */
.marquee /deep/ p {
  display: inline-block;
  white-space: nowrap;
  min-width: var(--marquee-width);
  user-select: none;
  mask-image: linear-gradient(
    90deg,
    transparent 0,
    black 4%,
    black 96%,
    transparent 100%
  );
  mask-size: calc(var(--marquee-width) + 5px) 100%;
  mask-position: -5px 0;
  mask-repeat: no-repeat;
}
</style>
